/** @format */

import { KillSwitches } from '@shared/data-access/interfaces';

const killSwitchProd: KillSwitches = {
  // please keep in alpha order
  devOnlyMswEnabled: {
    dsg: false,
    gg: false,
    pl: false,
    g3: false,
  },
  crossChainBopis: {
    dsg: true,
    gg: true,
    pl: true,
    g3: false,
  },
  enableTooltipSurvey: {
    dsg: true,
    gg: true,
    pl: false,
    g3: false,
  },
  enableAvailabilityApiBrandDomain: {
    dsg: false,
    gg: false,
    pl: false,
    g3: false,
  },
  enableSearchApiBrandDomain: {
    dsg: false,
    gg: false,
    pl: false,
    g3: false,
  },
  // Gates elastic.searchTermUrlByChain in ProductCatalogService; distinct from enableSearchApiBrandDomain (seo/product/category APIs above)
  useProductCatalogBrandDomains: {
    dsg: false,
    gg: false,
    pl: false,
    g3: false,
  },
  filterByCustomerRatingEnabled: {
    dsg: false,
    gg: false,
    pl: false,
    g3: false,
  },
  honeycombEnabled: {
    dsg: true,
    gg: false,
    pl: false,
    g3: false,
  },
  isPLPMLIntegrationEnabled: {
    dsg: true,
    gg: true,
    pl: true,
    g3: false,
  },
  isPLPRedisEnabled: {
    dsg: true,
    gg: true,
    pl: true,
    g3: true,
  },
  isSRLPRedisEnabled: {
    dsg: false,
    gg: false,
    pl: false,
    g3: false,
  },
  ecommScriptsEnabled: {
    dsg: false,
    gg: false,
    pl: false,
    g3: false,
  },
  sameDayDeliveryEnabled: {
    dsg: true,
    gg: true,
    pl: false,
    g3: false,
  },
  showPinnedContent: {
    dsg: true,
    gg: true,
    pl: true,
    g3: true,
  },
  clpGoogleAdManagerEnabled: {
    dsg: true,
    gg: true,
    pl: false,
    g3: false,
  },
  plpGoogleAdManagerEnabled: {
    dsg: true,
    gg: true,
    pl: false,
    g3: false,
  },
  showPLPSponsoredProducts: {
    dsg: true,
    gg: true,
    pl: false,
    g3: false,
  },
  plpSearchResultSurveyEnabled: {
    dsg: true,
    gg: true,
    pl: false,
    g3: true,
  },
  plpFilterResultSurveyEnabled: {
    dsg: true,
    gg: true,
    pl: true,
    g3: false,
  },
  plpShowCustomerRating: {
    dsg: true,
    gg: true,
    pl: true,
    g3: true,
  },
  compareCheckboxEnabled: {
    dsg: true,
    gg: true,
    pl: true,
    g3: false,
  },
  isUsingCriteoSPAAdServer: {
    dsg: true,
    gg: true,
    pl: false,
    g3: false,
  },
  plpDmnAdServerEnabled: {
    dsg: true,
    gg: true,
    pl: false,
    g3: false,
  },
  srlpDmnAdServerEnabled: {
    dsg: true,
    gg: true,
    pl: false,
    g3: false,
  },
  isSPAPosition2Enabled: {
    dsg: true,
    gg: true,
    pl: false,
    g3: false,
  },
  isSPAShelfEnabled: {
    dsg: false,
    gg: false,
    pl: false,
    g3: false,
  },
  isDigitalShelfTalkerEnabled: {
    dsg: true,
    gg: true,
    pl: false,
    g3: false,
  },
  isCriteoVideoEnabled: {
    dsg: false,
    gg: false,
    pl: false,
    g3: false,
  },
  isPLPNarrowGAMBannerEnabled: {
    dsg: true,
    gg: true,
    pl: false,
    g3: false,
  },
  isSRLPNarrowGAMBannerEnabled: {
    dsg: true,
    gg: true,
    pl: false,
    g3: false,
  },
  isEvergreenContentEnabled: {
    dsg: false,
    gg: false,
    pl: false,
    g3: false,
  },
  isEndNodeOnlyEnabled: {
    dsg: true,
    gg: true,
    pl: false,
    g3: false,
  },
  fulfillmentFacetsEnabled: {
    dsg: true,
    gg: false,
    pl: false,
    g3: false,
  },
  sortByCustomerRatingEnabled: {
    dsg: false,
    gg: false,
    pl: false,
    g3: false,
  },
  exposedFiltersEnabled: {
    dsg: false,
    gg: false,
    pl: false,
    g3: false,
  },
  exposedFiltersStickyOnMobile: {
    dsg: false,
    gg: false,
    pl: false,
    g3: false,
  },
  movefulfillmentOptionsToFilters: {
    dsg: false,
    gg: false,
    pl: false,
    g3: false,
  },
  moreOptionsQVEnabled: {
    dsg: false,
    gg: false,
    pl: false,
    g3: false,
  },
  moreOptionsPDPEnabled: {
    dsg: false,
    gg: false,
    pl: false,
    g3: false,
  },
  golfCartCheckoutIconEnabled: {
    dsg: false,
    gg: false,
    pl: false,
    g3: false,
  },
  useAEMForPCS: {
    dsg: false,
    gg: false,
    pl: false,
    g3: false,
  },
};

export default killSwitchProd;
